import React, { useEffect } from "react"
import { connect } from "react-redux"
import {
  viewOrder,
  saveUserAddress,
  setCheckoutDetailConfirmed,
} from "../../redux/actionCreators/orderAndPayments"
import "./CheckoutPage.scss"
import _ from "lodash"
import {
  ORDER_PLACED,
  YOUR_ORDER_MESSAGE,
  PARTNER_ORDER_MESSAGE,
  WAITING_FOR_PARTNER_TO_COMPLETE,
  COMBINED_ORDER_MESSAGE,
} from "../../constants/messages"
import { emptyDeliveryDotComCart } from "../../redux/actionCreators/planDinnner"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import { PAYMENT_PROCESSING } from "../../constants/notificationMsg"
import { goBackToPlanADate } from "./CheckoutUtils"

const OrderSuccessPage = props => {
  const {
    viewOrder,
    cartDetailsPartner1,
    cartDetailsPartner2,
    partnerDetails,
    user,
    isLoading,
  } = props
  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const myDetails = {}
  const yourDetails = {}
  const partnerOrderId = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID
  )
  const userOrderId = _.get(userState, FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID)
  const partnerPayStatus = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.PAY_STATUS}.${FIREBASE_STATE_KEYS.STATUS}`
  )
  // Disable Back Button in Order Success page
  useEffect(() => {
    // Setting page screen status and title to null to add state to browser's session history stack
    window.history.pushState(null, null, window.location.href)
    window.onpopstate = e => {
      // If disabled redirect back to same page
      window.history.go(1)
    }
  }, [])

  useEffect(() => {
    // Pay by self
    if (_.isEmpty(partnerPayStatus)) {
      return
    }
    if (
      partnerPayStatus !== "SELF" ||
      (partnerPayStatus === "SELF" && partnerOrderId)
    ) {
      async function _goBackToPlanADate() {
        await goBackToPlanADate(
          props,
          dateState,
          userState,
          partnerState,
          isOrderCombined
        )
      }
      _goBackToPlanADate()
    }
  }, [userOrderId, partnerOrderId])

  if (
    partnerDetails &&
    partnerDetails.partner1 &&
    partnerDetails.partner1.username === user.username
  ) {
    myDetails["cart"] = cartDetailsPartner1
    myDetails["displayName"] = _.get(user, "display_name", "")
    myDetails["last_name"] = _.get(partnerDetails, "partner1.last_name", "")
    yourDetails["cart"] = cartDetailsPartner2
    yourDetails["displayName"] = _.get(
      partnerDetails,
      "partner2.display_name",
      ""
    )
    yourDetails["last_name"] = _.get(partnerDetails, "partner2.last_name", "")
  } else {
    myDetails["cart"] = cartDetailsPartner2
    myDetails["displayName"] = _.get(user, "display_name", "")
    myDetails["last_name"] = _.get(partnerDetails, "partner2.last_name", "")
    yourDetails["cart"] = cartDetailsPartner1
    yourDetails["displayName"] = _.get(
      partnerDetails,
      "partner1.display_name",
      ""
    )
    yourDetails["last_name"] = _.get(partnerDetails, "partner1.last_name", "")
  }
  const userOrderNumber = _.get(
    userState,
    `${[FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID]}`,
    0
  )
  const partnerOrderNumber = _.get(
    partnerState,
    `${[FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID]}`,
    0
  )

  const partnerDisplayName = _.get(
    partnerState,
    `${[FIREBASE_STATE_KEYS.USER_DETAILS]}.${[
      FIREBASE_STATE_KEYS.DISPLAY_NAME,
    ]}`
  )

  const isOrderCombined = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.IS_ORDER_COMBINED}`,
    false
  )

  const getContent = () => {
    return (
      <React.Fragment>
        <div id="order-box" className="checkout-waiting">
          <div className="order-text">{ORDER_PLACED}</div>
          {isOrderCombined ? (
            <div className="order-info">
              {COMBINED_ORDER_MESSAGE(userOrderNumber || partnerOrderNumber)}
            </div>
          ) : (
            <div>
              <div className="order-info">
                {YOUR_ORDER_MESSAGE(userOrderNumber || partnerOrderNumber)}
              </div>
              {partnerOrderNumber ? (
                <div>
                  {PARTNER_ORDER_MESSAGE(
                    partnerDisplayName,
                    partnerOrderNumber
                  )}
                </div>
              ) : (
                <div>{WAITING_FOR_PARTNER_TO_COMPLETE(partnerDisplayName)}</div>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }

  const waitForPlacingOrder = () => {
    return (
      <React.Fragment>
        <div className="checkout-waiting">{PAYMENT_PROCESSING}</div>
      </React.Fragment>
    )
  }

  return (
    <div id="CheckoutPage">
      {isLoading ? waitForPlacingOrder() : getContent()}
    </div>
  )
}

const mapStateToProps = state => {
  const {
    orderAndPayments: {
      cartDetailsPartner1,
      cartDetailsPartner2,
      isLoading,
      payStatus,
      partnerConfirmedCheckoutDetails,
      checkoutHeaderMessage,
      confirmedCheckoutDetail,
    },
    planDinner: { restaurantSuggested },
    invitePeople: { partnerDetails },
    auth: { user },
  } = state
  return {
    cartDetailsPartner1,
    cartDetailsPartner2,
    restaurantSuggested,
    partnerDetails,
    user,
    isLoading,
    payStatus,
    partnerConfirmedCheckoutDetails,
    checkoutHeaderMessage,
    confirmedCheckoutDetail,
  }
}
export default connect(mapStateToProps, {
  viewOrder,
  saveUserAddress,
  setCheckoutDetailConfirmed,
  emptyDeliveryDotComCart,
})(OrderSuccessPage)
